import { FocusAreaEnum } from 'libs/end-to-end/src/focus-area';
import { RootCauseDivergedBarGraphGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseGenericBarGraphGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseAnalysis } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseBinScatterControlledVsUncontrolledGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseBinScatterGroup } from 'libs/end-to-end/src/root-cause-analysis';
import { RootCauseBinScatterGroupTrendline } from 'libs/end-to-end/src/root-cause-analysis';
import { number } from 'libs/end-to-end/src/factories/number.factory';

export const rootCauseAnalysis = (
  overrides?: Partial<RootCauseAnalysis>,
): RootCauseAnalysis => {
  return {
    sections: [
      {
        focusArea: FocusAreaEnum.Values.Hiring,
        subSections: [
          {
            demographic: 'RaceAsian',
            bulletPoints: [
              'some bullet point',
              'another bullet point',
              'and another bullet point',
            ],
          },
        ],
      },
    ],
    ...(overrides ?? {}),
  };
};

export const rootCauseBinScatterGroupTrendline = (
  overrides?: Partial<RootCauseBinScatterGroupTrendline>,
): RootCauseBinScatterGroupTrendline => {
  return {
    X0: number({ min: 0 }),
    X1: number({ min: 0 }),
    Y0: number({ min: 0 }),
    Y1: number({ min: 0 }),
    slope: number({ min: 0, max: 5 }),
    ...(overrides ?? {}),
  };
};

export const rootCauseBinScatterGroup = (
  overrides?: Partial<RootCauseBinScatterGroup>,
): RootCauseBinScatterGroup => {
  return {
    name: 'some root cause bin scatter group name',
    trendline: rootCauseBinScatterGroupTrendline(),
    ...(overrides ?? {}),
  };
};

export const rootCauseBinScatterControlledVsUncontrolledGroupResult = (
  overrides?: Partial<RootCauseBinScatterControlledVsUncontrolledGroupResult>,
): RootCauseBinScatterControlledVsUncontrolledGroupResult => {
  return {
    plot_type: 'BinScatterControlledVsUncontrolled',
    explanation: {
      analysisType: 'Adding Variables',
      controlVariable: 'some control variable',
      diff: 5,
      focusArea: 'Hiring',
      referenceLevel: 'some reference level',
      treatmentLevel: 'some treatment level',
      variableToOutputMap: {
        'some control variable': 'some output variable',
      },
    },
    reference_level: rootCauseBinScatterGroup(),
    treatment_level: rootCauseBinScatterGroup(),
    control_variable: 'Shoe size',
    ...(overrides ?? {}),
  };
};

export const rootCauseGenericBarGraphGroupResult = (
  overrides?: Partial<RootCauseGenericBarGraphGroupResult>,
): RootCauseGenericBarGraphGroupResult => {
  return {
    plot_type: 'GenericBarGraph',
    control_variable: 'Age',
    x: ['A', 'B', 'C', '1', '2', '3'],
    y: [5, 15, -5, 10, 20, -10],
    text: 'Age Disparity Normal Text',
    ...(overrides ?? {}),
  };
};

export const rootCauseDivergedBarGraphGroupResult = (
  overrides?: Partial<RootCauseDivergedBarGraphGroupResult>,
): RootCauseDivergedBarGraphGroupResult => {
  return {
    plot_type: 'DivergedBarGraph',
    control_variable: 'Age',
    not_controlled_disparity: 15,
    controlled_disparity: -3,
    pct_difference: -100,
    text: {
      analysisType: 'Oaxaca Beta',
      controlVariable: 'some control variable',
      diff: 5,
      focusArea: 'Hiring',
      referenceLevel: 'some reference level',
      treatmentLevel: 'some treatment level',
      variableToOutputMap: {
        'some control variable': 'some output variable',
      },
    },
    ...(overrides ?? {}),
  };
};
